module.exports = __webpack_public_path__ + "static/media/bg-story-carousel.35d4d5bd.svg";